/**
 * Update URL in the given element when user is lead
 *
 * @param element
 * @param newURL
 */

export const updateElementURLWhenUserIsLead = (element, newURL = '', openInNewWindow = false) => {
  const formFieldsStorage = window.fullstackacademy.formFieldsStorage();
  const emailValue = formFieldsStorage.getField('email');
  const coursePreferenceValue = formFieldsStorage.getField('course_preference');
  if (emailValue && coursePreferenceValue && newURL !== '') {
    element.href = newURL;
    element.target = openInNewWindow ? '_blank' : '_self';
  }
}
